(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-auto-slide"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
  $(".slider").slick({
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
  });

  $(".slider").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
    $(".slick-slide").removeClass("fade-in");
  });

  $(".slider").on("afterChange", function(event, slick, currentSlide) {
    $(".slick-current").addClass("fade-in");
  });

  // Ticking machine
  var percentTime;
  var tick;
  var time = .1;
  var progressBarIndex = 0;

  $('.progressBarContainer .progressBar').each(function(index) {
    var progress = "<div class='inProgress inProgress" + index + "'> </div>";
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
      progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
      startProgressbar();
    } else {
      percentTime += 1 / (time + 5);
      $('.inProgress' + progressBarIndex).css({
        width: percentTime + "%"
      });
      if (percentTime >= 100) {
        $('.single-item').slick('slickNext');
        progressBarIndex++;
        if (progressBarIndex > 2) {
          progressBarIndex = 0;
        }
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $('.inProgress').css({
      width: 0 + '%'
    });
    clearInterval(tick);
  }

  startProgressbar();

  // End ticking machine

  $('.item').click(function () {
    clearInterval(tick);
    var goToThisIndex = $(this).find("span").data("slickIndex");
    $('.single-item').slick('slickGoTo', goToThisIndex, false);
    startProgressbar();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-banner-auto"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function openCity(evt, index) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    tabcontent[index].style.display = "block";
    for (let i = 0; i < tabcontent.length; i++) {
      if (getComputedStyle(tabcontent[i]).display === "block") {
        tabcontent[i].classList.add("slide-active");
      } else if (getComputedStyle(tabcontent[i]).display === "none") {
        tabcontent[i].classList.remove("slide-active");
      }
    }
    if (evt) {
      evt.currentTarget.className += " active";
    } else {
      var activeTab = document.querySelector(`.tab-img div[data-index="${index}"]`);
      activeTab.className += " active";
    }
  }

  let intervalID;
  let currentIndex = 0;

  const tabdivs = document.querySelectorAll('.tab-img div');
  const tabContents = document.querySelectorAll('.tabcontent');

  function autoSwitchTabs() {
    currentIndex = (currentIndex + 1) % tabContents.length;
    openCity(null, currentIndex);
  }

  function startAutoSwitch() {
    intervalID = setInterval(autoSwitchTabs, 2000);
  }

  function stopAutoSwitch() {
    clearInterval(intervalID);
  }

  // Initialize first tab
  openCity(null, currentIndex);
  startAutoSwitch();

  tabdivs.forEach((div, index) => {
    div.addEventListener('mouseenter', () => {
      stopAutoSwitch();
      openCity(null, index);
    });
    div.addEventListener('mouseleave', () => {
      currentIndex = index;
      startAutoSwitch();
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-blog"] && !window.DesignMode) return;
  try {
    
   $('.blg-slide').slick({
        dots: true,
        infinite: true,
        // autoplay:true,
        // speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
  nextArrow: '.ltf',
  prevArrow: '.rtf',
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
           {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }

        ]
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-counter"] && !window.DesignMode) return;
  try {
    
              function inVisible(element) {
    var WindowTop = $(window).scrollTop();
    var WindowBottom = WindowTop + $(window).height();
    var ElementTop = element.offset().top;
    var ElementBottom = ElementTop + element.height();
    if ((ElementBottom <= WindowBottom) && ElementTop >= WindowTop)
      animate(element);
  }

  function animate(element) {
    if (!element.hasClass('ms-animated')) {
      var maxval = element.data('max');
      var html = element.html();
      element.addClass("ms-animated");
      $({
        countNum: element.html()
      }).animate({
        countNum: maxval
      }, {
        //duration 5 seconds
        duration: 5000,
        easing: 'linear',
        step: function() {
          element.html(Math.floor(this.countNum) + html);
        },
        complete: function() {
          element.html(this.countNum + html);
        }
      });
    }

  }

  //When the document is ready
  $(function() {
    //This is triggered when the
    //user scrolls the page
    $(window).scroll(function() {
      //Checking if each items to animate are
      //visible in the viewport
      $("span[data-max]").each(function() {
        inVisible($(this));
      });
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !window.DesignMode) return;
  try {
    
  jQuery(function ($) {

  	var $question = $('.question');
  	var $answer = $('.answer');

  	$question.click(function(){

  		// Hide all answers
  		$answer.slideUp();

  		// Check if this answer is already open
  		if($(this).hasClass('open')){
  			// If already open, remove 'open' class and hide answer
  			$(this).removeClass('open')
  			       .next($answer).slideUp();
  		// If it is not open...
  		}else{
  			// Remove 'open' class from all other questions
  			$question.removeClass('open');
  			// Open this answer and add 'open' class
  			$(this).addClass('open')
  			       .next($answer).slideDown();

  		}
  	});

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-logo-sider"] && !window.DesignMode) return;
  try {
    
  function addAnimation() {
      const scrollers = document.querySelectorAll(".logos");
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
      const scrollerInner = scroller.querySelector(".logos-slide"); // Corrected class name
      const scrollerContent = Array.from(scrollerInner.children);
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }
    addAnimation();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-priceing-slider"] && !window.DesignMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function () {
            const sliderTrack = document.getElementById('slider-track');
            const slides = Array.from(sliderTrack.children);

            // Clone the slides to create an infinite effect
            slides.forEach(slide => {
                const clone = slide.cloneNode(true);
                sliderTrack.appendChild(clone);
            });

            // Pause animation on hover
            sliderTrack.addEventListener('mouseover', () => {
                sliderTrack.style.animationPlayState = 'paused';
            });

            sliderTrack.addEventListener('mouseout', () => {
                sliderTrack.style.animationPlayState = 'running';
            });
        });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testmonial-slider"] && !window.DesignMode) return;
  try {
    
// const swiper = new Swiper('.swiper', {
//     // Optional parameters
//    autoplay:
//     {
//       delay: 1500,
//     },

//     direction: 'horizontal',
//     loop: true,
//     slidesPerView: 3,
//     spaceBetween: 10,
//     // If we need pagination
//     pagination: {
//       el: '.swiper-pagination',
//     },

//     // Navigation arrows
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//   });
      $('.testmonial').slick({
        dots: true,
        infinite: true,
        autoplay:true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
  nextArrow: '.left-arrow',
  prevArrow: '.right-arrow',
         responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
           {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }

        ]
      });

  } catch(e) { console.error(e); }
})();
})();
